import type { InstallmentCalculatorConfig } from './installmentCalculator.types';

export const installmentCalculatorConfig: InstallmentCalculatorConfig = {
  hasLegalHints: false,
  legalHintsImage: null,
  hasInfoCallToAction: true,
  InstallmentCalculatorCallToActionLayout: { layout: 'SideBySideWithTipBadge' },
  hasSpecialCreditColors: false,
  resetInstallmentsOnPriceChange: true,
};
